  document.getElementById("readmore")?.addEventListener("click", showMore);
            document.getElementById("readless")?.addEventListener("click", showLess);
          
            function showMore(event){
              event.preventDefault();
              var descriptionFull = document.querySelector('.collection-description-full');
              descriptionFull.style.display = 'block';
              var descriptionShort = document.querySelector('.collection-description-short');
              descriptionShort.style.display = 'none';
            }
          
            function showLess(event){
               event.preventDefault();
                var descriptionFull = document.querySelector('.collection-description-full');
                descriptionFull.style.display = 'none';
                var descriptionShort = document.querySelector('.collection-description-short');
                descriptionShort.style.display = 'block';
            }